export function setHomeTab (state, value) {
  state.homeTab = value
}
